import { Component, ViewChild, ChangeDetectionStrategy, input, output } from '@angular/core';
import { SatPopover } from '@zerops/zef/popover';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { storeUserData } from '@zerops/zerops/core/user-base';
import { ClientUser } from '@zerops/models/client-user';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { CLIENT_ADD_DIALOG_FEATURE_NAME } from '@zerops/zerops/feature/client-add-dialog';

@Component({
  selector: 'z-client-user-select-pop',
  templateUrl: './client-user-select-pop.container.html',
  styleUrls: [ './client-user-select-pop.container.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientUserSelectPopContainer extends ZefReactiveComponent {

  // # Event Streams
  onSelectClientUser$ = new Subject<ClientUser>();
  onCreateOrganization$ = new Subject<void>();

  // # Inputs
  clientUsers = input<ClientUser[]>();
  title = input<string>();
  // Switching org is a hard reload; org-agnostic screens can ask to be
  // returned to instead of the default projects dashboard.
  redirectTo = input<string>();

  // Fires on an actual selection, so a host can carry state across the reload
  // this triggers without also acting on a popover that was merely opened.
  clientUserSelected = output<ClientUser>();

  // # Data
  @ViewChild('popRef', { static: true })
  popRef: SatPopover;

  // # Action Streams
  #storeUserDataAction$ = this.onSelectClientUser$.pipe(
    tap((clientUser) => this.clientUserSelected.emit(clientUser)),
    map(({ userId, id }) => storeUserData(userId, id, true, this.redirectTo()))
  );
  #onCreateOrganizationAction$ = this.onCreateOrganization$.pipe(
    map(() => zefDialogOpen({ key: CLIENT_ADD_DIALOG_FEATURE_NAME }))
  );

  constructor() {
    super();

    // # Dispatcher
    this.$dispatchActions([
      this.#storeUserDataAction$,
      this.#onCreateOrganizationAction$
    ]);
  }

}
